import * as React from 'react'

export type Slide = {
  key: string
  title: string
  graphic?: React.ReactElement
  description?: string
  raw?: React.ReactElement
  showBackButton?: boolean
  showNextButton?: boolean
  showReadyToDashButton: boolean
  showMoreQuestionsButton?: boolean
  showPagination?: boolean
}

export enum SlideDecks {
  SlideDeck1 = 'slidedeck1',
  SlideDeck2 = 'slidedeck2',
  HowToDashSlideDeck = 'how-to-dash-slide-deck',
  SlideDeckVideo = 'slidedeckvideo',
}

export enum SlideButtons {
  Next = 'next',
  ReadyToDash = 'ready',
  // MoreQuestions = 'more-questions', (coming in phaze 2)
}

export enum Direction {
  Forward = 'forward',
  Back = 'back',
}
